import { useEffect, useRef, useState } from 'react'

import { CommonMapEnlarge2Icon } from '@local/assets/icons'

import Map, { MapProps } from '@web/components/Map/New'
import { CustomMarkerOption } from '@web/components/Map/New/types'
import { getCenterByMarkerOption } from '@web/components/Map/New/unit'
import { convertPlaceToMarkerOptions } from '@web/pages/v5/home/DailyBriefingSection/helper'
import styles from '@web/ui/pages/home/components/Sections/UIDailyBriefingSection/components/DailyBriefingStaticMap.module.scss'

export interface DailyBriefingPlacePrimitive {
  id?: string
  name: string
  coordinate: {
    latitude: number
    longitude: number
  }
  images: string[]
  category: {
    categoryCodeList: string[]
  }
  phone?: string
}

type Props = {
  onClick?: () => void
  place: DailyBriefingPlacePrimitive
  showOnClickMap: boolean
}

/**
 * @see https://wiki.navercorp.com/pages/viewpage.action?pageId=2558051605
 * 홈 > 데일리브리핑 > 다이나믹맵 (이미지 마커 표시 위해)
 */
const DailyBriefingMap = ({ onClick, place, showOnClickMap }: Props) => {
  const mapRef = useRef<naver.maps.Map>()
  const [markerOptions, setMarkerOptions] = useState<CustomMarkerOption[]>([])

  const handleMapReady: MapProps['onMapReady'] = map => {
    if (map) {
      let markerOptions = convertPlaceToMarkerOptions(place)
      setMarkerOptions(markerOptions)

      const [latestMarker] = markerOptions
      if (latestMarker) {
        const center = getCenterByMarkerOption({ map, markerOption: latestMarker })
        map.setCenter(center)
        return
      }
    }
  }

  useEffect(() => {
    if (place && mapRef.current) {
      let markerOptions = convertPlaceToMarkerOptions(place)
      setMarkerOptions(markerOptions)
      const [latestMarker] = markerOptions
      if (latestMarker) {
        mapRef.current.setCenter(latestMarker.position)
        return
      }
    }
  }, [place])

  return (
    <div className={styles.map_area}>
      <Map
        mapRef={mapRef}
        className={styles.map}
        onMapReady={handleMapReady}
        markerOptions={markerOptions}
        onClick={onClick}
        panToMarkerSelect={false}
        initMapOptions={{
          zoom: 15,
          draggable: false,
          scaleControl: false,
          logoControl: false,
          disableDoubleClickZoom: true,
          disableDoubleTapZoom: true,
          disableKineticPan: true,
          disableTwoFingerTapZoom: true,
          pinchZoom: false,
          zoomControl: false,
          scrollWheel: false,
        }}
      />
      {showOnClickMap && (
        <span className={styles.icon_wrapper}>
          <CommonMapEnlarge2Icon className={styles.icon} aria-hidden="true" />
          <span className="place_blind">지도보기</span>
        </span>
      )}
    </div>
  )
}

export default DailyBriefingMap
